import * as pc from 'playcanvas';

import type { CameraConfig } from './scene-types';

/**
 * Apply a scene's `camera.initial` pose to an existing camera entity.
 *
 * When `camera.initial` is absent, the caller is responsible for computing a
 * pose from the scene's bounding box (see `frame-bounds.ts`, future).
 */
export function applyInitialCamera(
    cameraEntity: pc.Entity,
    cameraCfg: CameraConfig | undefined
): void {
    const initial = cameraCfg?.initial;
    if (!initial) return;

    cameraEntity.setPosition(initial.position[0], initial.position[1], initial.position[2]);
    cameraEntity.lookAt(initial.target[0], initial.target[1], initial.target[2]);

    if (typeof initial.fov === 'number' && cameraEntity.camera) {
        cameraEntity.camera.fov = initial.fov;
    }
}

/**
 * Once all scene elements are loaded, fit the camera's clip planes to the
 * scene bounds. Called every frame in the editor; for the viewer we only
 * need it on load (the rotating-mode controller does it during user input).
 */
export function fitClipPlanes(cameraEntity: pc.Entity, scene: pc.Scene): void {
    const cam = cameraEntity.camera;
    if (!cam) return;

    // PlayCanvas exposes scene bounds via the renderer; for a one-shot fit we
    // approximate using the root entity's aabb computed across all RenderComponents.
    // Without dedicated bound tracking we fall back to a generous default range.
    cam.nearClip = 0.01;
    cam.farClip = 1000;

    // Touch `scene` to acknowledge param — kept for future bound-aware sizing.
    void scene;
}
